const Command = {
    requestFirmwareVersion: "0000",        // REQ_FW_VER
    responseFirmwareVersion: "0001",       // RSP_FW_VER
  
    requestHardwareVersion: "0010",        // REQ_HW_VERSION
    responseHardwareVersion: "0011",       // RSP_HW_VERSION
  
    requestDeviceInfo: "0100",             // REQ_DEV_INFO
    responseDeviceInfo: "0101",            // RSP_DEV_INFO
  
    requestDisplayLine: "0200",            // REQ_DISP_LINE
    responseDisplayLine: "0201",           // RSP_DISP_LINE
    notificateDisplayComplete: "0202",     // NOTI_DISP_LINE
  
    notificatePanningKey320: "0312",       // NOTI_KEY_PANNING (320 cell)
    notificatePanningKey20: "0302",        // NOTI_KEY_PANNING (20 cell)
    notificateFunctionKey: "0332",         // NOTI_KEY_FUNCTION (320 cell)
  
    requestDisplayPartial: "0220",         // REQ_DISP_PARTIAL
    responseDisplayPartial: "0221",        // RSP_DISP_PARTIAL
    notificateDisplayPartial: "0222",      // NOTI_DISP_PARTIAL

    requestVibration: "0530",              // REQ_VIBRATION
    responseVibration: "0531",             // RSP_VIBRATION

    requestBatteryLevel: "0610",           // REQ_BATTERY_LEVEL
    responseBatteryLevel: "0611",          // RSP_BATTERY_LEVEL
   
    reponseDisplayError: "9902"            // RSP_DISP_ERROR
};

export {
    Command
}
